import { defineMessages } from "react-intl";

const messages = defineMessages({
    title: {
        id: "error.404.title",
    },
});

export default messages;
